import { reportConstants } from '../constants';
import { alertActions } from 'actions';
import { reportService } from 'services';
import { global } from 'config';

//using for portal pricing
export const reportActions = {
  get
};

function get(report_category, report_name, filters) {
  return dispatch => {
    dispatch(request());

    reportService.get(report_category, report_name, filters)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: reportConstants.GET_REPORT_REQUEST } }
  function success(data) { return { type: reportConstants.GET_REPORT_SUCCESS, data } }
  function failure(error) { return { type: reportConstants.GET_REPORT_FAILURE, error } }
}
